<template>
    <div style="background-color: white; padding: 10px 20px">
        <div v-if="showList">
            <div style="display: flex">
                <div style="line-height: 40px">
                    <label class="primaryColor">Học viên :</label> ({{students.length}})
                </div>
                <div style="text-align: right;flex-grow: 1">
                    <v-btn dark round color="primary" @click="addToList">
                        <v-icon>add</v-icon>
                        Thêm học viên vào danh sách
                    </v-btn>
                    <v-btn dark round class="yoprimary" @click="addToClass">
                        <v-icon>add</v-icon>
                        Thêm học viên vào lớp
                    </v-btn>

                </div>
            </div>
            <v-data-table :headers="studentHeaders" :items="students" class="elevation-1 gru-table fixed-header"
                          :rows-per-page-items="rowsPerPageItems"
                          :pagination.sync="pagination"
            >
                <template slot="headers">
                    <tr>
                        <th v-for="header in studentHeaders" :width="header.width" :class="[
                  header.sortable?'column sortable active':'',
                  (header.value == sortField && orderBy=='desc') ? 'desc' : 'asc'
                ]"
                            @click="changeSort(header)"
                        >
                            <div v-if="header.value=='checkbox'" style="text-align: center">
                                <v-checkbox color="primary" hide-details v-model="selectAll"></v-checkbox>
                            </div>
                            <div v-else :style="header.headerStyle">
                                {{$t(header.text)}}
                                <v-icon small class="no-print" v-if="header.sortable && header.value ==sortField">
                                    arrow_upward
                                </v-icon>
                            </div>
                        </th>
                    </tr>
                    <tr class="grey lighten-3 no-print filter">
                        <td v-for="header in studentHeaders" class="text-xs-left gru-filter">
                            <div v-if="header.search==true" class="border-and-box">
                                <v-text-field single-line
                                              hide-details
                                              v-model.trim="student[header.value]"
                                              :placeholder="'Tìm kiếm '+ header.text"
                                              v-on:keyup.enter="init"
                                              small
                                              flat
                                />
                            </div>
                            <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                        </td>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.index+1 + parseInt(pagination.page-1) *
                        parseInt(pagination.rowsPerPage)}}
                    </td>
                    <td class="text-xs-left">
                        <v-btn @click="viewDetailOfStudent(props.item.userId)" class="mx-0" icon
                               title="Thông tin học viên">
                            <i-avatar :user-id="props.item.userId"/>
                        </v-btn>
                        {{ props.item.fullName }}
                    </td>
                    <td class="text-xs-left">{{ props.item.email }}</td>
                    <td class="text-xs-left">{{ props.item.phone }}</td>
                    <td class="text-xs-left">
                        <v-switch v-model="props.item.status" label="On" @change="changeStatus(props.item)"/>
                        <!--
                                            {{ getStatusName(props.item.status) }}
                        -->
                    </td>
                    <td class="justify-center">
                        <v-btn @click="viewClassOfStudent(props.item.studentId)" class="mx-0" icon
                               v-if="props.item.classes != null"
                               title="Danh sách lớp">
                            <v-icon color="primary">list_alt</v-icon>
                        </v-btn>
                    </td>
                    <td class="justify-center">
                        <v-btn @click="deleteStudent(props.item.studentId)" class="mx-0" icon
                               v-if="props.item.status == 0"
                               title="Xóa khỏi danh sách">
                            <v-icon color="pink">delete</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div v-else class="yocontent">
            <member-detail :editing-member="editingMember" :user="editingUser" :view-type="viewType" @cancel="showList=true"/>
        </div>

        <v-dialog max-width="900px" v-model="sDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="sDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Thêm học viên vào danh sách
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <div v-if="step==0">
                                    <div style="margin-bottom: 10px;margin-top: -20px">Nhập thông tin học viên sẽ thêm
                                        vào
                                        Danh sách
                                    </div>
                                    <div style="max-height: 400px;overflow-y: auto">
                                        <v-form @keyup.enter.native="enterInList">
                                            <v-data-table :headers="addStudentHeaders" :items="lstInsertStudent"
                                                          class="elevation-1" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <td class="text-xs-center">{{props.index+1}}</td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" :id="'fullName_'+props.index"
                                                               :key="'fullName_'+props.index"
                                                               :row="props.index" :col="0"
                                                               v-model="props.item.fullName"/>
                                                        <div class="error--text">{{err.fullName[props.index]}}</div>
                                                    </td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" v-model="props.item.email"
                                                               @change="getStudentInfo(props.item,props.index)"
                                                               :key="'email_'+props.index"
                                                               :id="'email_'+props.index" :row="props.index" :col="1"/>
                                                        <div class="error--text">{{err.email[props.index]}}</div>

                                                    </td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" v-model="props.item.phone"
                                                               @change="getStudentInfo(props.item,props.index)"
                                                               title="Nhập số điện thoại thông thường ví dụ 0988888888"
                                                               :key="'phone_'+props.index"
                                                               :id="'phone_'+props.index" :row="props.index" :col="2"/>
                                                        <div class="error--text">{{err.phone[props.index]}}</div>

                                                    </td>
                                                    <td class="justify-center">
                                                        <v-btn @click="removeInsertStudent(props.index)"
                                                               class="mx-0" icon>
                                                            <v-icon color="pink">delete</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-form>
                                    </div>
                                    <v-btn flat @click="pushEmptyStudent" class="primaryColor">
                                        <v-icon>add</v-icon>
                                        Thêm dòng
                                    </v-btn>
                                </div>
                                <div v-else class="result_info">
                                    <div>{{unSuccessCount}}/{{lstInsertStudent.length}} Học viên bạn vừa nhập thông tin
                                        đã có tên trong Danh sách Học viên.
                                    </div>
                                    <div>Số học viên thêm mới vào Danh sách học viên là
                                        {{successCount}}/{{lstInsertStudent.length}} học viên.
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onAddToList" class="yoprimary" v-if="step==0" dark>Thêm vào danh sách</v-btn>
                    <v-btn @click="sDialog=false" class="yoprimary" v-else-if="step==1" dark>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="800px" v-model="scDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline"
                         style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                        <v-btn @click="scDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Danh sách lớp của học
                        viên
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <v-data-table key="select_class" :headers="studentClassHeader" :items="lstClass"
                                              v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center">
                                            <v-btn @click="deleteStudentClass(props.item.classId)" class="mx-0" icon
                                                   title="Học sinh rời lớp">
                                                <v-icon color="pink">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                                <v-data-table key="select_student" :headers="studentSelectHeaders"
                                              :rows-per-page-items="rowsPerPageItems"
                                              :items="lstSelectStudent" v-else-if="step==1"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.item.fullName }}</td>
                                        <td class="text-xs-left">{{ props.item.email }}</td>
                                        <td class="text-xs-left">{{ props.item.phone }}</td>
                                        <td class="text-xs-left">{{ getAccountStatus(props.item.userId) }}</td>
                                        <td class="justify-center">
                                            <input :key="props.item.studentId" class="tableInput" type="checkbox"
                                                   v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <div v-else>
                                    <div style="line-height: 30px" class="primaryColor">Thêm {{lstSelectStudent.length}}
                                        học viên vào lớp
                                    </div>
                                    <div style="color: red;line-height: 30px">Có {{lstCreateStudent.length}} chưa có tài
                                        khoản Yoclass. Bạn sẽ tạo tài khoản cho học viên?
                                    </div>
                                    <v-data-table key="non_account_student" :headers="studentCreateHeaders"
                                                  :items="lstCreateStudent"
                                                  class="elevation-1" hide-actions>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index+1 }}</td>
                                            <td class="text-xs-left">{{ props.item.fullName }}</td>
                                            <td class="text-xs-left">{{ getUserName(props.item) }}</td>
                                            <td class="text-xs-left">
                                                <input :key="'create_'+props.item.studentId" class="tableInput"
                                                       v-model="props.item.password"/>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="scDialog=false" v-if="step==0" color="cancel" dark>
                        {{$t("lang.common.close")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="900px" v-model="cDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="cDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Thêm học viên vào lớp
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <div v-if="step==0">Chọn lớp:</div>
                                <div v-if="step==1">Chọn học viên:</div>
                                <v-data-table key="select_class" :headers="classHeader" :items="lstClass" v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="headers">
                                        <tr>
                                            <th v-for="header in classHeader" :width="header.width"
                                            >
                                                <div v-if="header.value=='checkbox'" style="text-align: center">
                                                    <v-checkbox color="primary" hide-details
                                                                v-model="selectAll"></v-checkbox>
                                                </div>
                                                <div v-else :style="header.headerStyle">
                                                    {{$t(header.text)}}
                                                    <v-icon small class="no-print"
                                                            v-if="header.sortable && header.value ==sortField2">
                                                        arrow_upward
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr class="grey lighten-3 no-print filter">
                                            <td v-for="header in classHeader" class="text-xs-left gru-filter">
                                                <div v-if="header.search==true" class="border-and-box">
                                                    <v-text-field single-line
                                                                  hide-details
                                                                  v-model.trim="search"
                                                                  v-on:keyup.enter="getClass"
                                                                  :placeholder="'Tìm kiếm '+ header.text"
                                                                  dense
                                                                  type="text"
                                                                  small
                                                    />
                                                </div>
                                                <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-center">{{props.index+1}}
                                        </td>
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center"><input :key="props.item.classId" class="tableInput"
                                                                          type="checkbox"
                                                                          v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <v-data-table key="select_student" :headers="studentSelectHeaders"
                                              :rows-per-page-items="rowsPerPageItems"
                                              :items="lstSelectStudent" v-else-if="step==1"
                                              :pagination.sync="pagination2"
                                              class="elevation-1 gru-table fixed-header">
                                    <template slot="headers">
                                        <tr>
                                            <th v-for="header in studentSelectHeaders" :width="header.width" :class="[
                  header.sortable?'column sortable active':'',
                  (header.value == sortField2 && orderBy2=='desc') ? 'desc' : 'asc'
                ]"
                                                @click="changeSort2(header)"
                                            >
                                                <div v-if="header.value=='checkbox'" style="text-align: center">
                                                    <v-checkbox color="primary" hide-details
                                                                v-model="selectAll"></v-checkbox>
                                                </div>
                                                <div v-else :style="header.headerStyle">
                                                    {{$t(header.text)}}
                                                    <v-icon small class="no-print"
                                                            v-if="header.sortable && header.value ==sortField2">
                                                        arrow_upward
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr class="grey lighten-3 no-print filter">
                                            <td v-for="header in studentSelectHeaders" class="text-xs-left gru-filter">
                                                <div v-if="header.search==true" class="border-and-box">
                                                    <v-text-field single-line
                                                                  hide-details
                                                                  v-model.trim="student2[header.value]"
                                                                  v-on:keyup.enter="searchStudent2"
                                                                  dense
                                                                  type="text"
                                                                  small
                                                                  :placeholder="'Tìm kiếm '+ header.text"
                                                    />
                                                </div>
                                                <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-center">{{ props.index+1 + parseInt(pagination2.page-1) *
                                            parseInt(pagination2.rowsPerPage)}}
                                        <td class="text-xs-left">{{ props.item.fullName }}</td>
                                        <td class="text-xs-left">{{ props.item.email }}</td>
                                        <td class="text-xs-left">{{ props.item.phone }}</td>
                                        <td class="text-xs-left">{{ getAccountStatus(props.item.userId) }}</td>
                                        <td class="justify-center">
                                            <label v-if="props.item.userId != null && props.item.userId>0"
                                                   style="margin-right: 5px">Thêm vào lớp</label>
                                            <label v-else style="margin-right: 5px">Tạo tài khoản</label>
                                            <input :key="props.item.studentId" class="tableInput" type="checkbox"
                                                   v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <div v-else-if="step==2">
                                    <div style="line-height: 30px" class="primaryColor"
                                         v-if="numberOfAddingStudent - lstCreateStudent.length>0">Bạn đã thêm
                                        {{numberOfAddingStudent - lstCreateStudent.length}}/{{numberOfAddingStudent}}
                                        học viên vào lớp {{lstSelectedClass[0].className}}
                                    </div>
                                    <div style="color: red;line-height: 30px">Có
                                        {{lstCreateStudent.length}}/{{numberOfAddingStudent}} chưa có tài
                                        khoản Yoclass. Bạn sẽ tạo tài khoản cho học viên?
                                    </div>
                                    <v-data-table key="non_account_student" :headers="studentCreateHeaders"
                                                  :items="lstCreateStudent"
                                                  class="elevation-1" hide-actions>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index+1 }}</td>
                                            <td class="text-xs-left">{{ props.item.fullName }}</td>
                                            <td class="text-xs-left">{{ getUserName(props.item) }}</td>
                                            <td class="text-xs-left">
                                                <input :key="'create_'+props.item.studentId" class="tableInput"
                                                       v-model="props.item.password"/>
                                                <div class="error--text">{{err.password[props.index]}}</div>
                                            </td>
                                        </template>
                                    </v-data-table>
                                    <div style="font-style: italic">Học viên được thêm vào lớp học khi đã có tài khoản
                                        Yoclass*
                                    </div>
                                </div>
                                <div v-else-if="step==3" class="result_info">
                                    <div>Bạn đã tạo tài khoản Yoclass cho {{createdSuccess}} học viên <br/>
                                        Thông tin tài khoản và mật khẩu đăng nhập Yoclass.vn
                                        sẽ được gửi tới học viên theo email/số điện thoại vừa tạo.
                                    </div>
                                    <div> {{createdSuccess}} Học viên này sẽ được thêm vào lớp
                                        "{{lstSelectedClass[0].className}}"
                                    </div>
                                </div>
                                <div v-else class="result_info">
                                    <div>Bạn đã hoàn thành thêm {{numberOfAddingStudent}} học viên cho lớp.
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="onAddToClass" v-if="step==0" class="yoprimary" dark>Chọn lớp</v-btn>
                    <v-btn @click.native="onInsertToClass" v-else-if="step==1" class="yoprimary" dark>Thêm vào lớp
                    </v-btn>
                    <v-btn @click.native="onCreateAccount" v-else-if="step==2" class="yoprimary" dark>Tạo tài khoản
                    </v-btn>
                    <v-btn @click.native="cDialog=false" class="yoprimary" v-else dark>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--v-dialog max-width="600px" v-model="uDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline"
                         style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                        <v-btn @click="uDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Thêm học viên vào lớp
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <v-data-table key="select_class" :headers="classHeader" :items="lstClass" v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center"><input :key="props.item.classId" class="tableInput"
                                                                          type="checkbox"
                                                                          v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <v-data-table key="select_student" :headers="studentSelectHeaders"
                                              :rows-per-page-items="rowsPerPageItems"
                                              :items="lstSelectStudent" v-else-if="step==1"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.item.fullName }}</td>
                                        <td class="text-xs-left">{{ props.item.email }}</td>
                                        <td class="text-xs-left">{{ props.item.phone }}</td>
                                        <td class="text-xs-left">{{ getAccountStatus(props.item.userId) }}</td>
                                        <td class="justify-center">
                                            <input :key="props.item.studentId" class="tableInput" type="checkbox"
                                                   v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <div v-else>
                                    <div style="line-height: 30px" class="primaryColor">Thêm {{lstSelectStudent.length}}
                                        học viên vào lớp
                                    </div>
                                    <div style="color: red;line-height: 30px">Có {{lstCreateStudent.length}} chưa có tài
                                        khoản Yoclass. Bạn sẽ tạo tài khoản cho học viên?
                                    </div>
                                    <v-data-table key="non_account_student" :headers="studentCreateHeaders"
                                                  :items="lstCreateStudent"
                                                  class="elevation-1" hide-actions>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index+1 }}</td>
                                            <td class="text-xs-left">{{ props.item.fullName }}</td>
                                            <td class="text-xs-left">{{ getUserName(props.item) }}</td>
                                            <td class="text-xs-left">
                                                <input :key="'create_'+props.item.studentId" class="tableInput"
                                                       v-model="props.item.password"/>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="onAddToClass" v-if="step==0" class="yoprimary" dark>Chọn lớp</v-btn>
                    <v-btn @click.native="onInsertToClass" v-else-if="step==1" class="yoprimary" dark>Thêm vào lớp
                    </v-btn>
                    <v-btn @click.native="onInsertToClass" v-else class="yoprimary" dark>Tạo tài khoản</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog-->
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import {CrudService} from "@/services";
    import Validator from "../../../public/js/validator";
    import MemberDetail from "../class/memberDetail";

    const v = Validator();

    export default {
        name: "student-component",
        components: {MemberDetail},
        props: {
            exerciseType: {
                type: String | Number,
                default: null
            },
            value: {
                type: Boolean,
                default: false
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            viewType:"student",
            editingMember: null,
            editingUser: null,
            showList:true,
            step: 0,
            sortField: "fullName",
            orderBy: "asc",
            sortField2: "fullName",
            orderBy2: "asc",
            sDialog: false,
            scDialog: false,
            cDialog: false,
            uDialog: false,
            studentHeaders: [
                {
                    text: "STT",
                    align: "left",
                    search: false,
                    sortable: false,
                    value: "name"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "fullName"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "email"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "phone"
                },
                {
                    text: "Trạng thái",
                    align: "left",
                    sortable: true,
                    search: false,
                    value: "status"
                },
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "studentId"
                },
                {
                    text: "Xóa",
                    align: "left",
                    sortable: false,
                    value: "studentId"
                }
            ],
            studentSelectHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "fullName",
                    width: "20%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "email",
                    width: "20%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "phone",
                    width: "10%"
                },
                {
                    text: "Tài khoản Yoclass",
                    align: "left",
                    sortable: false,
                    value: "status",
                    width: "15%"
                },
                {
                    text: "Hành động",
                    align: "left",
                    sortable: false,
                    value: "studentId",
                    width: "30%"
                }
            ],
            addStudentHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Xử lý",
                    value: "name",
                    align: "center",
                    sortable: false,
                    width: "10%"
                }
            ],
            studentCreateHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Tên người dùng (Username)",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "Mật khẩu",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                }
            ],
            classHeader: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "classId"
                },
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    search: true,
                    value: "className"
                },
                {
                    text: "Chọn",
                    align: "center",
                    sortable: false,
                    value: "status"
                }
            ],
            studentClassHeader: [
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    value: "className"
                },
                {
                    text: "Xử lý",
                    align: "center",
                    sortable: false,
                    value: "status"
                }
            ],
            students: [],
            student: {},
            student2: {status: 1},
            lstInsertStudent: [],
            lstCreateStudent: [],
            lstClass: [],
            lstSelectedClass: [],
            lstStudentClass: [],
            lstSelectStudent: [],
            numberOfAddingStudent: 0,
            unSuccessCount: 0,
            successCount: 0,
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
                orderBy: 'fullName',
                descending: false
            },
            pagination2: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
                orderBy: 'fullName',
                descending: false
            },

        }),

        watch: {
            value(val) {
                this.sDialog = val;
                this.init();
            },

            sDialog(val) {
                if (val == false) {
                    this.init();
                } else {
                    this.step = 0;
                }
            },

            cDialog: function (val) {
                if (val == false) {
                    this.init();
                }
            },

            scDialog(val) {
                if (val == false) {
                    this.init();
                }
            }
        },

        created() {
            //this.init();
            //this.getClass();
        },
        methods: {
            getStudentInfo(item, index) {
                let url = process.env.VUE_APP_API_URL + "/school/student";
                axios
                    .post(url, item)
                    .then(
                        data => {
                            if (data == null || data == "") {

                            } else {
                                item = data;
                                if(item.userId != null && (item.studentId == null || item.studentId == 0)){
                                    message.error("Thông tin tài khoản bạn vừa nhập trùng với tài khoản giáo viên nên không thể đưa vào danh sách");
                                    item['email'] = "";
                                    item["phone"] = "";
                                    item["fullName"] = "";
                                    this.lstInsertStudent.splice(index, 1,item);
                                    document.getElementById("fullName_" + index).focus();
                                } else {
                                    document.getElementById("email_" + index).disabled = true;
                                    document.getElementById("phone_" + index).disabled = true;
                                    document.getElementById("fullName_" + index).disabled = true;
                                    //let newarr = this.lstInsertStudent;
                                    //newarr[index] =  item;
                                    this.lstInsertStudent.splice(index, 1, item);
                                }
                                //console.log(this.lstInsertStudent);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },
            disableExistItem() {
                for (let i = 0; i < this.lstInsertStudent.length; i++) {
                    let disabled = false;
                    if (this.lstInsertStudent[i].studentId > 0 || this.lstInsertStudent[i].userId > 0) {
                        disabled = true;
                    }
                    document.getElementById("email_" + i).disabled = disabled;
                    document.getElementById("phone_" + i).disabled = disabled;
                    document.getElementById("fullName_" + i).disabled = disabled;
                }
            },
            enterInList: function (e) {
                console.log(e);
                let row = parseInt(e.target.getAttribute("row"));
                let col = parseInt(e.target.getAttribute("col"));
                console.log(row + "-" + col);
                let next = "";
                if (col < 2) {
                    if (col == 0) {
                        next = "email_" + row;
                    } else {
                        next = "phone_" + row;
                    }
                    document.getElementById(next).focus();
                } else {
                    console.log(row + "-")
                    if (row == this.lstInsertStudent.length - 1) {
                        this.pushEmptyStudent();
                        this.$nextTick(() => {
                            row += 1;
                            next = "fullName_" + row;
                            console.log(next);
                            document.getElementById(next).focus();
                        })
                    } else {
                        row += 1;
                        next = "fullName_" + row;
                        console.log(next);
                        document.getElementById(next).focus();
                    }
                }
            },

            changeSort: function (header) {
                if (!header.sortable) {
                    return;
                }
                console.log(this.sortField + "-" + this.orderBy);
                let descending = true;
                if (this.sortField == header.value) {
                    if (this.orderBy == "asc") {
                        this.orderBy = "desc";
                    } else {
                        this.orderBy = "asc";
                        descending = false;
                    }
                } else {
                    this.sortField = header.value;
                    this.orderBy = "asc";
                    descending = false;
                }
                this.pagination = {
                    rowsPerPage: 10,
                    page: 1,
                    orderBy: header.value,
                    descending: descending
                };
                console.log(this.pagination);

                this.init();
            },
            changeSort2: function (header) {
                if (!header.sortable) {
                    return;
                }
                let descending = true;
                if (this.sortField2 == header.value) {
                    if (this.orderBy2 == "asc") {
                        this.orderBy2 = "desc";
                    } else {
                        this.orderBy2 = "asc";
                        descending = false;
                    }
                } else {
                    this.sortField2 = header.value;
                    this.orderBy2 = "asc";
                    descending = false;
                }
                this.pagination2 = {
                    rowsPerPage: 10,
                    page: 1,
                    orderBy: header.value,
                    descending: descending
                };
                this.searchStudent2();
            },
            getUserName: function (student) {
                if (student.email != null && student.email != "") {
                    return student.email;
                } else {
                    return student.phone;
                }
            },
            getAccountStatus: function (studentId) {
                if (studentId == null || studentId == 0) {
                    return "Chưa có";
                } else {
                    return "Đã có";
                }
            },
            getStatusName(status) {
                if (status == 0) {
                    return "Chưa duyệt";
                } else if (status == 1) {
                    return "Đã duyệt"
                } else if (status == -1) {
                    return "Đã xóa"
                } else {
                    return "";
                }
            },
            init() {
                let url = process.env.VUE_APP_API_URL + "/school/students?";
                if (this.sortField != null) {
                    url += "orderBy=" + this.sortField;
                    if (this.orderBy != null) {
                        url += "&sort=" + this.orderBy;
                    }
                }
                axios
                    .post(url, this.student)
                    .then(
                        data => {
                            this.students = data;
                            console.log(this.students);
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },
            searchStudent2() {
                let url = process.env.VUE_APP_API_URL + "/school/students?";
                if (this.sortField != null) {
                    url += "orderBy=" + this.sortField2;
                    if (this.orderBy != null) {
                        url += "&sort=" + this.orderBy2;
                    }
                }
                axios
                    .post(url, this.student2)
                    .then(
                        data => {
                            this.lstSelectStudent = data;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },
            getClass() {
                let url = process.env.VUE_APP_API_URL + "/class/myclass?";
                if (this.search != null && this.search != "") {
                    url += "search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.lstClass = data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },
            addToList() {
                this.sDialog = true;
                this.lstInsertStudent = [];
                this.err.fullName = [];
                this.err.email = [];
                this.err.phone = [];
                this.pushEmptyStudent();
            },
            pushEmptyStudent() {
                this.lstInsertStudent.push({
                    "fullName": "",
                    "email": "",
                    "phone": ""
                });
                this.err.fullName.push("");
                this.err.email.push("");
                this.err.phone.push("");
                this.$nextTick(() => {
                    this.disableExistItem();
                })
            },

            onAddToList() {
                if (this.lstInsertStudent.length == 0) {
                    message.error("Bạn chưa nhập thông tin học viên");
                    return;
                }

                this.err = {
                    fullName: Array(this.lstInsertStudent.length).fill(""),
                    email: Array(this.lstInsertStudent.length).fill(""),
                    phone: Array(this.lstInsertStudent.length).fill("")
                }
                let validate = true;
                for (let i = 0; i < this.lstInsertStudent.length; i++) {
                    if (this.lstInsertStudent[i].fullName == null || this.lstInsertStudent[i].fullName.trim().length == 0) {
                        this.err.fullName[i] = "Không được phép để trống";
                        validate = false;
                    }
                    if ((this.lstInsertStudent[i].email == null || this.lstInsertStudent[i].email.trim().length == 0)
                        && (this.lstInsertStudent[i].phone == null || this.lstInsertStudent[i].phone.trim().length == 0)) {
                        this.err.email[i] = "Không được phép để trống cả email và số điện thoại";
                        this.err.phone[i] = "Không được phép để trống cả email và số điện thoại";
                        validate = false;
                    } else {
                        if ((this.lstInsertStudent[i].email != null && this.lstInsertStudent[i].email.trim().length > 0)) {
                            if (!v.validateEmail(this.lstInsertStudent[i].email)) {
                                this.err.email[i] = "Không đúng định dạng email";
                                validate = false;
                            }

                        }

                        if ((this.lstInsertStudent[i].phone != null && this.lstInsertStudent[i].phone.trim().length > 0)) {
                            if (!v.validatePhone(this.lstInsertStudent[i].phone)) {
                                this.err.phone[i] = "Không đúng định dạng số điện thoại";
                                validate = false;
                            }
                        }
                    }

                }
                if (!validate) {
                    return;
                }
                let url = process.env.VUE_APP_API_URL + "/school/addStudents?";
                axios
                    .post(url, this.lstInsertStudent)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Thêm mới thành công");
                                this.unSuccessCount = data.ref.unSuccessCount;
                                this.successCount = data.ref.successCount;
                                this.step = 1;
                                //this.sDialog = false;
                                //this.init();
                            } else {
                                message.error("Thêm mới không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            removeInsertStudent(index) {
                this.lstInsertStudent.splice(index, 1);
                this.err.fullName.splice(index, 1);
                this.err.email.splice(index, 1);
                this.err.phone.splice(index, 1);
            },

            viewClassOfStudent(studentId) {
                this.studentId = studentId;
                this.step = 0;
                axios.post(process.env.VUE_APP_API_URL + "/school/studentClass?studentId=" + this.studentId).then(
                    data => {
                        /*
                                                let classes = [];
                                                for (let i = 0; i < this.lstClass.length; i++) {
                                                    this.lstClass[i].selected = false;
                                                    if (data != null && data != "") {
                                                        for (let j = 0; j < data.length; j++) {
                                                            if (data[j].classId == this.lstClass[i].classId) {
                                                                this.lstClass[i].selected = true;
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    classes.push(this.lstClass[i]);
                                                }
                        */
                        this.lstClass = data;
                        this.scDialog = true;
                    },
                    error => {

                    }
                )
            },

            changeStatus(item) {
                console.log(item);
                let cf, status;
                if (item.status) {
                    cf = confirm("Bạn có chắc muốn mở khóa học viên?");
                    status = 1;
                } else {
                    cf = confirm("Bạn có chắc muốn khóa học viên?");
                    status = 0;
                }
                if (!cf) {
                    item.status = !item.status;
                    //console.log(item.status);
                } else {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/school/changeStudentStatus?studentId=" + item.studentId + "&status=" + status)
                        .then(
                            data => {
                                if (data.success) {
                                    if (item.status) {
                                        message.success("Mở khóa học viên thành công");
                                    } else {
                                        message.success("Khóa học viên thành công");
                                    }
                                    this.init();
                                } else {
                                    message.error("Xóa không thành công");
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }

            },

            deleteStudent(studentId) {
                let cf = confirm("Bạn có chắc muốn xóa học viên khỏi danh sách?");
                if (!cf) {
                    return;
                }
                axios
                    .post(process.env.VUE_APP_API_URL + "/school/deleteStudent?studentId=" + studentId)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Xóa học sinh thành công");
                                this.init();
                            } else {
                                message.error("Xóa không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            deleteStudentClass(classId) {
                let cf = confirm("Bạn có chắc rời học sinh khỏi lớp?");
                if (!cf) {
                    return;
                }
                axios
                    .post(process.env.VUE_APP_API_URL + "/school/deleteStudentClass?studentId=" + this.studentId + "&classId=" + classId)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Rời học sinh thành công");
                                this.viewClassOfStudent(this.studentId);
                            } else {
                                message.error("Rời học sinh không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            addToClass() {
                this.cDialog = true;
                this.studentId = null;
                this.step = 0;
                this.getClass();
            },

            onAddToClass() {
                this.lstSelectedClass = [];
                for (let i = 0; i < this.lstClass.length; i++) {
                    if (this.lstClass[i].selected) {
                        this.lstSelectedClass.push(this.lstClass[i]);
                    }
                }
                if (this.lstSelectedClass.length == 0) {
                    message.error("Bạn chưa chọn lớp");
                    return;
                }

                if (this.studentId != null) {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/school/insertStudentClass?studentId=" + this.studentId, insertClass)
                        .then(
                            data => {
                                if (data.success) {
                                    message.success("Thêm mới thành công");
                                    this.cDialog = false;
                                    this.init();
                                } else {
                                    message.error("Thêm mới không thành công");
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                } else {
                    this.step = 1;
                    this.searchStudent2();
                }

            },

            onCreateAccount() {
                this.err = {
                    fullName: Array(this.lstCreateStudent.length).fill(""),
                    email: Array(this.lstCreateStudent.length).fill(""),
                    phone: Array(this.lstCreateStudent.length).fill(""),
                    password:Array(this.lstCreateStudent.length).fill(""),
                }
                let validate =true;
                for (let i = 0; i < this.lstCreateStudent.length; i++) {
                    if (this.lstCreateStudent[i].password == null || this.lstCreateStudent[i].password.trim().length == 0) {
                        this.err.password[i] = "Không được phép để trống";
                        validate = false;
                    } else if (this.lstCreateStudent[i].password.trim().length <8){
                        this.err.password[i] = "Mật khẩu phải dài ít nhất 8 kí tự";
                        validate = false;
                    }
                }
                if(validate) {
                    let url = process.env.VUE_APP_API_URL + "/school/createStudentOfClass?classId=" + this.lstSelectedClass[0].classId;
                    axios
                        .post(url, this.lstCreateStudent)
                        .then(
                            data => {
                                if (data.success) {
                                    this.createdSuccess = parseInt(data.ref)
                                    this.step = 3;
                                } else {
                                    message.error(data.description);
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }
            },

            onInsertToClass() {
                let classIds = null;
                this.lstSelectedClass = [];
                for (let i = 0; i < this.lstClass.length; i++) {
                    if (this.lstClass[i].selected) {
                        this.lstSelectedClass.push(this.lstClass[i]);
                        if (classIds == null) {
                            classIds = this.lstClass[i].classId;
                        } else {
                            classIds += "," + this.lstClass[i].classId;
                        }
                    }
                }
                let insertStudent = [];
                let createStudent = [];
                for (let i = 0; i < this.lstSelectStudent.length; i++) {
                    if (this.lstSelectStudent[i].selected) {
                        if (this.lstSelectStudent[i].userId == null || this.lstSelectStudent[i].userId == 0) {
                            createStudent.push(this.lstSelectStudent[i]);
                        } else {
                            insertStudent.push(this.lstSelectStudent[i]);
                        }
                    }
                }
                this.numberOfAddingStudent = insertStudent.length + createStudent.length;
                if (insertStudent.length == 0 && createStudent.length == 0) {
                    message.error("Bạn chưa chọn học sinh");
                    return;
                }
                //console.log(createStudent);

                if (this.step == 1) {
                    this.lstCreateStudent = createStudent;
                    if (insertStudent.length == 0) {
                        this.err = {
                            fullName: Array(this.lstCreateStudent.length).fill(""),
                            email: Array(this.lstCreateStudent.length).fill(""),
                            phone: Array(this.lstCreateStudent.length).fill(""),
                            password:Array(this.lstCreateStudent.length).fill(""),
                        }
                        this.step = 2;
                    } else {
                        axios
                            .post(process.env.VUE_APP_API_URL + "/school/inserMultiStudentClass?classIds=" + classIds, insertStudent)
                            .then(
                                data => {
                                    if (data.success) {
                                        if (this.lstCreateStudent.length == 0) {
                                            this.step = 4;
                                        } else {
                                            this.err = {
                                                fullName: Array(this.lstCreateStudent.length).fill(""),
                                                email: Array(this.lstCreateStudent.length).fill(""),
                                                phone: Array(this.lstCreateStudent.length).fill(""),
                                                password:Array(this.lstCreateStudent.length).fill(""),
                                            }
                                            this.step = 2;
                                        }
                                    } else {
                                        message.error("Thêm mới không thành công");
                                    }
                                },
                                error => {
                                    message.error(error);
                                }
                            );
                    }
                }

            },

            viewDetailOfStudent(userId) {
                this.viewType = "student";
                CrudService.of('user').getItem(userId).then(user => {
                    this.editingMember = user;
                    this.editingUser = user;
                    this.showList= false;
                });
            }
        }
    };
</script>